import { useAuth } from "@/shared/auth/fetch/useAuth";
import { useNavigate } from "@tanstack/react-router";
import { useMemo } from "react";
import type { TheHeaderProps } from "../model/types";

export const useTheHeaderProps = (): TheHeaderProps => {
  const auth = useAuth();
  const navigate = useNavigate();

  const props = useMemo<TheHeaderProps>(() => {
    return {
      user: auth.session.isAuthenticated
        ? {
            isAuthenticated: true,
            ...auth.session.user,
          }
        : { isAuthenticated: false },
      onLoginClick: () => navigate({ to: "/login" }),
      onLogoutClick: () => {
        auth.logout();
        navigate({ to: "/login" });
      },
    };
  }, [auth.logout, auth.session, navigate]);
  return props;
};
